<template>
  <div>
    <span
      v-for="dat in emoji_data"
      :key="dat.index"
    >
    <emoji  v-if="dat.type=='emoji'" :emoji="dat.data"   set="apple" :size="16" />
    <span tabindex="-1" v-if="dat.type=='string'"
           class="text"
           :id="'chat_text_'+ index"
          v-html="myContent((dat.data))"
          >

               </span>
  </span>
  </div>
</template>
<script>
  import { bus } from '../../../main.js'
import Vue from 'vue'
  import { Emoji } from 'emoji-mart-vue'
  import emojiData from '../../../assets/emoji_apple_array'
  export default {
    components: {

      Emoji,
    },

    data () {
      return {
        emoji:'',
        emojies_arr:emojiData,
        data_array:[],
        emoji_data:[],
      }
    },
    props: {
      data: String,
      index:Number

    },
    beforeDestroy () {
    },
    mounted () {
      var self_8 = this
      var self = this
      // this.emojies_arr = Object.keys(this.emojies_arr).map((key) => [String(key), this.emojies_arr[key]]);
      self_8.data_array = [...self_8.data]
      // console.log('emojies_arr', this.data_array)
      // console.log("emojies_arr",this.data.codePointAt(0).toString(16))
     var code_point = ''
      var searched_emoji = []
      this.data_array.forEach(function (val, index) {
        code_point = val.codePointAt(0).toString(16).toUpperCase()
        searched_emoji = self.emojies_arr.filter(x => x[1].b == code_point)
        if (searched_emoji.length > 0) {
          self.emoji_data.push({ id:index, type:'emoji', data:searched_emoji[0][0] })
        } else {
          if (self.emoji_data.length > 0 && self.emoji_data[self.emoji_data.length - 1].type == 'string') {
            // self.emoji_data.push({id:index, type:'string', data:val })
            Vue.set(self.emoji_data[self.emoji_data.length - 1], 'data', self.emoji_data[self.emoji_data.length - 1].data + val)
            // self.emoji_data[index-1].data = self.emoji_data[index-1].data+val;
          } else {
            self.emoji_data.push({ id:index, type:'string', data:val })
          }
        }
     })
      // console.log('emoji array ', this.emoji_data)

      // this.emoji =  this.emojies_arr.filter(x=>x[1].b==this.data.codePointAt(0).toString(16).toUpperCase())[0][0]
      // console.log("emoji name is",this.emoji)
      // this.configRecording()

      // window.addEventListener('resize', this.resize_mobile, {passive: true})
      // this.resize_mobile()
    },

    watch: {},

    methods: {
      emojiFallback (emoji) {
        console.log('emoji fallback is', emoji)
        return ':smile:'
      },
      myContent(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g

        const markup = text
          .replace(/</g, '&lt;')
          .replace(/((?:href|src)=['"])(.*?)(['"])/g, (matched, prefix, href, suffix) => {
            return `${prefix}<a href="${href}" target="_blank">${href}</a>${suffix}`
          })
          .replace(urlRegex, function (url) {
          return '<a target="_blank" href="' + url + '">' + url + '</a>'
          })

        return markup
      },
      urlify (text) {
        return  text;
        var urlRegex = /(https?:\/\/[^\s]+)/g
        return text.replace(urlRegex, function (url) {
          return '<a target="_blank" href="' + url + '">' + url + '</a>'
        })
        // or alternatively
        // return text.replace(urlRegex, '<a href="$1">$1</a>')
      },
    }
  }
</script>
